import { PagedListPayloadSortingEntry } from 'framework/api';

// the grid's own sorting goes first; the base one only orders what it leaves equal
export function combineSorting(base: PagedListPayloadSortingEntry[], sorting: PagedListPayloadSortingEntry[]) {
	return [...sorting, ...base.filter((entry) => !sorting.some((x) => x.field == entry.field))];
}
